var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.929 3.035h-1.213V.88c0-.19-.155-.343-.344-.343H7.832c-.09 0-.178.036-.243.101l-.006.008-.01.008-4.702 4.662c-.016.015-.03.032-.043.052-.065.065-.1.15-.1.242v15.913c0 .189.154.343.343.343h2.196v1.254c0 .19.154.343.344.343h15.318c.19 0 .343-.154.343-.343V3.378c0-.189-.154-.343-.343-.343zM3.889 5.273l3.602-3.57.003 3.598-3.606-.028zm16.697-1.551v19.055H5.954v-.911h13.418c.19 0 .343-.154.343-.343V3.722h.87zM8.176 1.223H19.03V21.18H3.414V5.956l4.42.034h.01c.087 0 .17-.036.236-.1.065-.065.1-.152.1-.244l-.004-4.423z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.833 17.616h-4.096c-.189 0-.343.154-.343.343 0 .19.154.343.343.343h4.096c.19 0 .343-.154.343-.343 0-.19-.154-.343-.343-.343zM11.426 17.616h-5.98c-.188 0-.342.154-.342.343 0 .19.154.343.343.343h5.98c.189 0 .343-.154.343-.343 0-.19-.154-.343-.344-.343zM5.104 16.075c0 .19.154.343.343.343h11.386c.19 0 .343-.154.343-.343 0-.19-.154-.343-.343-.343H5.447c-.19 0-.343.154-.343.343zM10.116 14.534h6.717c.19 0 .343-.154.343-.343 0-.19-.154-.343-.343-.343h-6.717c-.189 0-.343.154-.343.343 0 .19.154.343.343.343zM5.447 14.534h2.17c.19 0 .344-.154.344-.343 0-.19-.154-.343-.343-.343H5.447c-.19 0-.343.154-.343.343 0 .19.154.343.343.343z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5417",
    fillRule: "evenodd",
    d: "M14.097 3.6c-1.656 0-2.997 1.344-2.997 3s1.341 3 2.997 3c1.659 0 3.003-1.344 3.003-3s-1.344-3-3.003-3zm.303 1.5h-.6v1.8h.6V5.1zm0 2.4h-.6v.6h.6v-.6zm-2.7-.9c0 1.326 1.074 2.4 2.4 2.4 1.326 0 2.4-1.074 2.4-2.4 0-1.326-1.074-2.4-2.4-2.4-1.326 0-2.4 1.074-2.4 2.4z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotices);
export default __webpack_public_path__ + "static/media/notices.63389f3e34a5f6e57cafd93308efb722.svg";
export { ForwardRef as ReactComponent };